<template>
    <tr>
        <td class="td-no_link">{{rowNumber}}</td>
        <td class="td-no_link">
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
                <input type="text"  class="form-control" v-model="item.name"/>
                <span v-if="errors && errors.name" class="help-block" >{{ errors.name }}</span>
            </div>
        </td>
        <td class="td-no_link">
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.unit) }">
                <input type="text" class="form-control" v-model="item.unit"/>
                <span v-if="errors && errors.unit" class="help-block" >{{ errors.unit }}</span>
            </div>
        </td>
        <td class="td-no_link">
            <div :class="{'form-group': true, 'has-error': (errors && errors.amount) }">
                <input type="text" class="form-control" v-model="item.amount"/>
                <span v-if="errors && errors.amount" class="help-block" >{{ errors.amount }}</span>
            </div>
        </td>
        <td class="td-no_link">
            <div :class="{'form-group': true, 'has-error': (errors && errors.price) }">
                <input type="text" id="_regon" class="form-control" v-model="item.price"/>
                <span v-if="errors && errors.price" class="help-block" >{{ errors.price }}</span>
            </div>
        </td>
        <td class="td-no_link">{{netPrice}}</td>
        <td class="td-no_link">
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.currency) }">
                <dropdown-search :elements="invoiceTaxType" emptyValue="Wybierz" nameField="name" v-model="taxType"/>
                <span v-if="errors && errors.currency" class="help-block" id="_currency_helpBlock">{{ errors.currency }}</span>
            </div>
        </td>
        <td class="td-no_link">{{tax}}</td>
        <td class="td-no_link">{{grossPrice}}</td>
        <td>
            <a href="#" title="Usuń" class="btn btn-icon btn-icon--warning" @click.prevent="removeItem(index)">
                <svg-icon name="minus"/>
            </a>
        </td>
    </tr>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        props: {
            values: {
                type: Array,
                required: true
            },
            errors: {
                type: Object
            },
            index: {
                type: Number,
                required: true
            },
            removeItem: {
              type: Function,
              required: true,
            },
        },
        data: function() {
           return {
                taxObject: null
            }
        },
        computed: {
            item: function () {
                return this.values[this.index]
            },
            tax: function () {
               const price = parseFloat(parseFloat(this.item.amount) * parseFloat(this.item.price) * (parseFloat(this.item.tax)/100)).toFixed(2)
               return price == 'NaN' ? '' : price;
            },
            netPrice: function () {
               const price = parseFloat(parseFloat(this.item.amount) * parseFloat(this.item.price)).toFixed(2)
               return price == 'NaN' ? '' : price;
            },
            grossPrice: function () {
               const price = parseFloat(parseFloat(this.item.amount) * parseFloat(this.item.price) + parseFloat(this.tax)).toFixed(2)
               return price == 'NaN' ? '' : price;
            },
            rowNumber: function () {
                return this.index + 1
            },
            taxType: {
                get: function () {
                  if(this.taxObject == null){
                      if(this.values[this.index].taxType !== undefined){
                          this.taxObject = this.invoiceTaxType.find((tax) => tax['@id'] == this.values[this.index].taxType);
                      }
                      else{
                          this.taxObject = this.invoiceTaxType.find((tax) => tax.tax == 23);
                          this.item.taxType = this.taxObject['@id'];
                      }
                  }
                  return   this.taxObject
                },
                set: function (newValue) {
                    this.taxObject = newValue;
                }
            },
            ...mapGetters({
                invoiceTaxType: 'config/config/invoiceTaxType'
            })
        },
        watch:{
            taxType: function (newValue) {
                this.item.tax = newValue.tax;
                this.item.taxName = newValue.name;
                this.item.taxType = newValue['@id'];
            },
            'item.amount': function (newValue) {
              if(newValue.indexOf(",") !== false ){
                this.item.amount= newValue.replace(/,/g, '.');
              }
            },
            'item.price': function (newValue) {
              if(newValue.indexOf(",") !== false ){
                this.item.price= newValue.replace(/,/g, '.');
              }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InvoiceItemForm.vue?41e1aa7e